// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","block":"Logo_block__E7Mev","img":"Logo_img__LdRhM"};